import { isHex } from './is-hex';

export function splitHex (colorStr: string) {
  if (!isHex(colorStr)) {
    return [];
  }
  const trimmedHex = colorStr.trim().slice(1);
  const splitBy = trimmedHex.length === 3 ? 1 : 2;

  return [ 'r', 'g', 'b' ].map((_, i) => {
    const sliceFrom = i * Number(splitBy);
    const sliceTo = (i + 1) * Number(splitBy);
    return parseInt(trimmedHex.slice(sliceFrom, sliceTo), 16).toString();
  });
}
